import { useNavigate } from 'react-router-dom'
import { clearSession } from '../../../infrastructure/api-signup'
import { setNewAccessToken } from '../../../infrastructure/apis'
import { useEffect } from 'react'
import LoadingPage from '../../static/LoadingPage'

export const CloseSession = () => {
    const navigate = useNavigate()

    useEffect(() => {
        clearSession()
            .catch(error => {
                setNewAccessToken(null)
                console.warn('Failed to clear session during logout:', {
                    status: (error as any)?.response?.status,
                    statusText: (error as any)?.response?.statusText,
                    message: (error as any)?.message,
                })
            })
            .finally(() => navigate('/login'))
    }, [navigate])

    return <LoadingPage />
}

export default CloseSession
